import { Heart, GraduationCap, HandHeart, Sparkles, Coffee, Users, Award, BookOpen } from "lucide-react";

const perks = [
  { icon: Heart, label: "Home-Like Culture", desc: "Warm relationships, respectful colleagues and a happy staffroom", color: "from-rose-500 to-pink-600" },
  { icon: GraduationCap, label: "Continuous Learning", desc: "Workshops, sanskaar sessions & modern pedagogy training", color: "from-sky-500 to-blue-600" },
  { icon: HandHeart, label: "Purpose-Filled Work", desc: "Every day, you shape the future of Bharat — one child at a time", color: "from-orange-500 to-red-500" },
  { icon: Coffee, label: "Wellness First", desc: "Yoga, healthy meals and mental-health breaks built into your day", color: "from-emerald-500 to-teal-600" },
  { icon: Users, label: "Community", desc: "Be part of a growing family of educators, parents and children", color: "from-fuchsia-500 to-purple-600" },
  { icon: Award, label: "Recognition", desc: "Celebrating your growth with awards, appraisals & leadership paths", color: "from-amber-500 to-orange-600" }
];

const CareersInfographic = () => (
  <section className="py-16 bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 relative overflow-hidden" data-testid="careers-infographic">
    <div className="absolute inset-0 opacity-10 pointer-events-none">
      <div className="absolute top-10 left-10 w-56 h-56 border-2 border-orange-400 rounded-full" />
      <div className="absolute bottom-10 right-10 w-72 h-72 border-2 border-amber-400 rounded-full" />
    </div>
    <div className="container mx-auto px-4 relative z-10">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <span className="inline-block text-[10px] font-bold text-orange-700 tracking-widest uppercase mb-2">Life at Aadi Gayanam</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-stone-800 mb-3">Where Teachers Grow Too</h2>
        <p className="text-stone-600 text-sm md:text-base">
          A teacher's job here isn't just to teach — it is to shine, learn, laugh and grow alongside every child. Six reasons wonderful educators call Aadi Gayanam home.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
        {perks.map((p) => {
          const Icon = p.icon;
          return (
            <div key={p.label} className="p-5 rounded-3xl bg-white border border-orange-100 shadow-md hover:shadow-2xl transition-all hover:-translate-y-1" data-testid={`career-perk-${p.label.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}>
              <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${p.color} flex items-center justify-center shadow mb-3`}>
                <Icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-display text-lg font-bold text-stone-800 mb-1">{p.label}</h3>
              <p className="text-sm text-stone-600 leading-relaxed">{p.desc}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-12 max-w-3xl mx-auto text-center bg-white rounded-3xl p-8 shadow-lg border border-orange-100">
        <BookOpen className="w-8 h-8 text-orange-600 mx-auto mb-3" />
        <p className="font-devanagari text-2xl text-orange-700 mb-2">आचार्य देवो भव।</p>
        <p className="text-stone-700 text-sm md:text-base italic">
          "Revere the teacher as God." — At Aadi Gayanam, we mean it.
        </p>
      </div>
    </div>
  </section>
);

export default CareersInfographic;
